function initBlogTabs() {
  const wrapper = document.querySelector('.blog-tab-section');
  if (!wrapper) return;

  const container = wrapper.querySelector('.blog-content-container');
  const sectionId = container.dataset.sectionId;

  wrapper.addEventListener('click', (e) => {
    const link = e.target.closest('.blog-tab a');
    if (!link) return;

    e.preventDefault();
    fetchAndReplace(link.href);
  });

  async function fetchAndReplace(url) {
    container.classList.add('is-loading');

    const fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set('section_id', sectionId);

    const res = await fetch(fetchUrl.toString());
    const html = await res.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newContainer = doc.querySelector('.blog-content-container');
    if (newContainer) container.innerHTML = newContainer.innerHTML;

    const newTabs = doc.querySelector('.blog-tab-container');
    const currentTabs = wrapper.querySelector('.blog-tab-container');
    if (newTabs && currentTabs) currentTabs.innerHTML = newTabs.innerHTML;

    container.classList.remove('is-loading');

    window.history.pushState({}, '', url);
    wrapper.scrollIntoView({ behavior: 'auto', block: 'start' });

    observeBlogList();

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (window.lenis) window.lenis.resize();
      });
    });
  }

  window.addEventListener('popstate', () => {
    fetchAndReplace(window.location.href);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBlogTabs);
} else {
  initBlogTabs();
}

// ===== もっと見るボタン =====
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.blog-load-more');
  if (!btn) return;

  const step = parseInt(btn.dataset.step, 10);
  const list = btn.closest('.blog-content-container').querySelector('.blog-list');
  const hiddenItems = list.querySelectorAll('.blog-list-item.is-hidden');

  hiddenItems.forEach((item, index) => {
    if (index < step) item.classList.remove('is-hidden');
  });

  const remaining = list.querySelectorAll('.blog-list-item.is-hidden').length;
  if (remaining === 0) btn.remove();

  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      if (window.lenis) {
        window.lenis.resize();
        // console.log('resize実行後のlimit:', window.lenis.limit);
        // console.log('scrollHeight:', document.body.scrollHeight);
      }
    });
  });
});

// ===== ResizeObserver：タブ切り替えのたびに、新しい.blog-listを監視し直す =====
let currentObserver = null;

function observeBlogList() {
  const blogList = document.querySelector('.blog-list');
  if (!blogList || !window.ResizeObserver) return;

  if (currentObserver) currentObserver.disconnect();

  currentObserver = new ResizeObserver(() => {
    if (window.lenis) window.lenis.resize();
  });
  currentObserver.observe(blogList);
}

observeBlogList();